const ralphLaurenBrandOutfitId: number = 45;

const ralphLaurenBrandMixAndMatchIdList: number[] = [2, 3];

export default {
  ralphLaurenBrandOutfitId,
  ralphLaurenBrandMixAndMatchIdList,
};
